import { httpservice, Message } from 'src/app/commons/commons.module';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pdv } from 'src/app/_models/Maticni/pdv';
import { Observable } from 'rxjs';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginatorIntlCro } from 'src/app/commons/commons.module';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogComponent } from 'src/app/_dialog/dialog.component';
import { Router } from '@angular/router';
import { PdvAddComponent } from 'src/app/maticni/pdv/pdvAdd.component';

@Component({
  selector: 'pdv',
  templateUrl: './pdv.component.html',
  styleUrls: ['./pdv.component.css']
})
export class PdvComponent implements OnInit {
  getservice: httpservice;
  displayedColumns: string[] = ['sifra','naziv','postotak'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selectedrow: any;
  lista: any;
  showAdd: boolean;
  currentItem: 0;


  constructor(dataservice: httpservice, public dialog: MatDialog, private router: Router) {
    this.getservice = dataservice;
    
  }
  ngOnInit() {

    this.showAdd = false;
    try {
      this.getservice.GetRequest<Message>("maticni/pdv/List").subscribe(result => {
        if (result.status === "success") {
          this.lista = new MatTableDataSource<Pdv>(Object.values(result.data));
          this.lista.paginator = this.paginator;
          setTimeout(() => this.lista.sort = this.sort, 2000);
          this.paginator._intl = new MatPaginatorIntlCro();
          if (this.lista.data.length > 0) {
            this.selectedrow = this.lista.data[0];
          }
        }
      }, error => console.error('Get zahtjev',error));
    }
    catch (error) {
      console.error('Log error', error);
    }   
  }
  

  highlight(row) {
    this.selectedrow = row;
  }

  add() {
    this.currentItem = 0;
    this.showAdd = true;
  }

  addItem(newItem: Pdv) {
    this.showAdd = false;
    if (newItem.pdvId > 0) {
      var ind = this.lista.data.findIndex(function checkUser(user) {
        return user.pdvId == newItem.pdvId;
      }, this);
      if (ind > -1) {
        this.lista.data[ind] = newItem;
      }
      else {
        this.lista.data.push(newItem);
      }
      this.selectedrow = newItem;
      this.lista._updateChangeSubscription();
    }
  }

  openDialog() {
    if (this.selectedrow) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          pitanje: 'Da li ste sigurni ?',
          pojasnjenje: 'Brisanje pdv stope ' + this.selectedrow.naziv
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.DeleteData();
        }
      });
    }
  }
  

  DeleteData() {
    var ind = this.lista.data.findIndex(function checkData(data) {
      return data.pdvId == this.selectedrow.pdvId;
    },this);
    if (ind > -1) {      
      this.getservice.PostRequest<Message>("maticni/pdv/Remove", this.selectedrow.pdvId).subscribe(result => {
        if (result.status === "success") {
          this.lista.data.splice(ind, 1);
          this.lista._updateChangeSubscription();
          this.selectedrow = null;
        }
      });
    }
  }

  

  EditData() {
    if (this.selectedrow) {      
      this.currentItem = this.selectedrow.pdvId;
      this.showAdd = true;      
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.lista.filter = filterValue.trim().toLowerCase();
  }  
}


